export function normalizeStatusValue(value) {
  const v = String(value || "")
    .trim()
    .toUpperCase();

  if (v === "ONLINE") return "ONLINE";
  if (v === "OFFLINE") return "OFFLINE";
  if (v === "ALERT") return "ALERT";
  if (v === "DISABLED") return "DISABLED";

  return "";
}

export function statusBadgeClass(status) {
  const v = String(status || "").toUpperCase();

  if (v === "ONLINE") {
    return "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300";
  }

  if (v === "ALERT") {
    return "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300";
  }

  if (v === "DISABLED") {
    return "bg-slate-100 text-slate-700 dark:bg-slate-500/15 dark:text-slate-300";
  }

  return "bg-gray-100 text-gray-700 dark:bg-white/10 dark:text-gray-300";
}

export function statusLabelText(status) {
  const v = String(status || "").toUpperCase();

  if (v === "ONLINE") return "온라인";
  if (v === "ALERT") return "위험";
  if (v === "DISABLED") return "비활성";

  return "오프라인";
}

export function isOfflineLikeStatus(status) {
  const v = String(status || "").toUpperCase();
  return v === "OFFLINE" || v === "DISABLED";
}